import IHasChildren from "@/types/IHasChildren"
import { Box, SxProps, Theme } from "@mui/material";
import { Dispatch, FC, SetStateAction } from "react"


export type ScreenLocation = "center" | "top" | "bottom";

export type AnchorLocation = {
    anchor: any;
    position: "top" | "bottom" | "left" | "right"
}

interface IPopupProps extends IHasChildren {
    open: boolean;
    setOpen?: Dispatch<SetStateAction<boolean>>;
    position?: ScreenLocation | AnchorLocation;
}

export const Popup: FC<IPopupProps> = ({
    open,
    setOpen,
    position,
    children
}) => {

    const pos: SxProps<Theme> = position === undefined ? 
        {
            position: 'absolute',
            top: '50%',
            left: '50%'
        } :

        typeof position === "string" ?      // ScreenLocation
            position === "top" ?
            {
                position: 'absolute',
                top: '10%',
                left: '50%'
            } :
            position === "bottom" ?
            {
                position: 'absolute',
                bottom: '10%',
                left: '50%'
            } :
            {
                position: 'absolute',
                top: '50%',
                left: '50%'
            } :

        {                                   // Anchor Location

        }

    return (
        <>
            {
                setOpen &&
                <Box
                    sx={{
                        display: open ? 'block' : 'none',
                        position: 'absolute',
                        top: '0',
                        left: '0',
                        width: '100vw',
                        height: '100vh',
                        background: '#22222255'
                    }}
                    onClick={() => setOpen(false)}
                />
            }
            <Box 
                sx={{
                    display: open ? 'flex' : 'none',
                    position: 'absolute',
                    zIndex: 1000,
                    transform: 'translate(-50%, -50%)',

                    ...pos,

                    minWidth: '100px',
                    minHeight: '50px'
                }}
            >
                {children}
            </Box>
        </>
    )
}

export default Popup;